import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import type { ContractProgramFamilyOption } from '@/types/contract';
import ajax from '@/utils/ajax';

const DugoutProgramFamilyRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async listActive(): Promise<ContractProgramFamilyOption[]> {
      const response = await ajax.get({
        url: `${host}/api/dugout/program_families/`,
        params: { active: 'true' }
      });
      return response.data as ContractProgramFamilyOption[];
    }
  };
};

export default DugoutProgramFamilyRepository;
